import React from 'react'
import {
  change as changeFieldValue, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import FormCadastrarFormaPagamento from './FormCadastrarFormaPagamento';
import calcularDescontoUsuario from '../../actions/desconto/calcularDescontoUsuario';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import selecionarAcrescimoPassagemCalculado from '../../actions/acrescimo-passagem/selecionarAcrescimoPassagemCalculado';
import calcularAcrescimoPassagem from '../../actions/acrescimo-passagem/calcularAcrescimoPassagem';

export class AbaFormaPagamento extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mensagem: { tipo: '', texto: '' },
      cartao: false,
      dinheiro: false,
      arquivo: null,
      valorTotalReserva: 0,
      habilitadoDescontoUsuarioIda: true,
      habilitadoAcrescimoPassagemIda: true,
      habilitadoDescontoUsuarioVolta: true,
      habilitadoAcrescimoPassagemVolta: true
    };
  }

  componentDidMount() {
    const valorTotal = this.props.calcularValorTotal();
    this.setState({ valorTotalReserva: valorTotal })

    if (!this.props.formasPagamento || this.props.formasPagamento.length == 0) {
      this.definirChecboxDinheiroComoOpcaoIncial(valorTotal);

      this.props.adicionarFormasPagamento([{
        tipo: 'Dinheiro',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: valorTotal,
        quantidadeParcelas: 1,
        descontoIda: null,
        descontoVolta: null
      }]);

    }
    else {
      this.preencherDadosFormaPagamento();
    }
  }

  definirChecboxDinheiroComoOpcaoIncial(valorTotalReserva) {
    this.props.changeFieldValue('formReserva', 'dinheiro', true);
    this.props.changeFieldValue('formReserva',
      'valorDinheiro', valorTotalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
  }

  alterarAba(aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba(aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem() {
    this.setState({ mensagem: undefined })
  }


  ehTipoEmissaoNormal(tipo) {
    return tipo === 'NORMAL'
  }

  habilitaOuDesabilitaDescontoUsuarioIda(valor) {
    this.setState({ habilitadoDescontoUsuarioIda: valor });
  }

  habilitaOuDesabilitaAcrescimoPassagemIda(valor) {
    this.setState({ habilitadoAcrescimoPassagemIda: valor });
  }

  habilitaOuDesabilitaDescontoUsuarioVolta(valor) {
    this.setState({ habilitadoDescontoUsuarioVolta: valor });
  }

  habilitaOuDesabilitaAcrescimoPassagemVolta(valor) {
    this.setState({ habilitadoAcrescimoPassagemVolta: valor });
  }

  permiteAcrescimoMaxmoUsuarioIda() {
    let normal = 0
    normal = this.props.passageirosIda.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemIda.acrescimoMaximoPassagem !== null
  }

  permiteAcrescimoMaximoUsuarioVolta() {
    let normal = 0
    normal += this.props.passageirosVolta.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemVolta.acrescimoMaximoPassagem !== null
  }

  permiteDescontoUsuarioRotaIda() {
    let normal = 0
    normal = this.props.passageirosIda.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemIda.descontoMaximoUsuarioRota !== null
  }

  permiteDescontoUsuarioRotaVolta() {
    let normal = 0
    normal += this.props.passageirosVolta.filter(passageiro => this.ehTipoEmissaoNormal(passageiro.tipoEmissao)).length
    return normal > 0 && this.props.viagemVolta.descontoMaximoUsuarioRota !== null
  }

  calcularDescontoUsuarioRotaIda(desconto) {
    if (this.permiteDescontoUsuarioRotaIda()) {
      let valorTotalIda = 0.00
      this.props.passageirosIda.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalIda += Number(passageiro.valor)
        }
      })
      const descontoMaximoUsuarioRota = Number(this.props.viagemIda.descontoMaximoUsuarioRota)
      const descontoInformado = Number(desconto)
      if (descontoMaximoUsuarioRota >= descontoInformado) {
        this.calcularDescontoUsuario(valorTotalIda, descontoInformado, 'IDA')
      }
    }
  }

  calcularDescontoUsuarioRotaVolta(desconto) {
    if (this.permiteDescontoUsuarioRotaVolta()) {
      let valorTotalVolta = 0.00
      this.props.passageirosVolta.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalVolta += Number(passageiro.valor)
        }
      })
      const descontoMaximoUsuarioRota = Number(this.props.viagemVolta.descontoMaximoUsuarioRota)
      const descontoInformado = Number(desconto)
      if (descontoMaximoUsuarioRota >= descontoInformado) {
        this.calcularDescontoUsuario(valorTotalVolta, descontoInformado)

      }
    }
  }

  calcularDescontoUsuario(valorTotal, descontoInformado, sentido) {
    this.props.calcularDescontoUsuario(valorTotal, descontoInformado)
      .then(resp => {
        if (resp.payload.status == 200) {
          this.props.selecionarDescontoInformado(descontoInformado)
          if (sentido == 'IDA') {
            this.props.selecionarDescontoUsuario({ ida: resp.payload.data, volta: this.props.valorDescontoUsuarioCalculado.volta })
          } else {
            this.props.selecionarDescontoUsuario({ ida: this.props.valorDescontoUsuarioCalculado.ida, volta: resp.payload.data })
          }
          const valorReserva = this.props.calcularValorTotal()
          this.setState({ valorTotalReserva: valorReserva })
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', valorReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));

        }
      })
  }

  calcularAcrescimoPassagemUsuarioIda(acrescimo) {
    if (this.permiteAcrescimoMaxmoUsuarioIda()) {
      let valorTotalIda = 0.00
      this.props.passageirosIda.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalIda += Number(passageiro.valor)
        }
      })
      const acrescimoMaximoPassagem = Number(this.props.viagemIda.acrescimoMaximoPassagem)
      const acrescimoInformado = Number(acrescimo)
      if (acrescimoMaximoPassagem >= acrescimoInformado) {
        this.calcularAcrescimoPassagem(valorTotalIda, acrescimoInformado, 'IDA')
      }
    }
  }

  calcularAcrescimoPassagemUsuarioVolta(acrescimo) {
    if (this.permiteAcrescimoMaximoUsuarioVolta()) {
      let valorTotalVolta = 0.00
      this.props.passageirosVolta.forEach(passageiro => {
        if (this.ehTipoEmissaoNormal(passageiro.tipoEmissao)) {
          valorTotalVolta += Number(passageiro.valor)
        }
      })
      const acrescimoMaximoPassagem = Number(this.props.viagemVolta.acrescimoMaximoPassagem)
      const acrescimoInformado = Number(acrescimo)
      if (acrescimoMaximoPassagem >= acrescimoInformado) {
        this.calcularAcrescimoPassagem(valorTotalVolta, acrescimoInformado)

      }
    }
  }

  calcularAcrescimoPassagem(valorTotal, acrescimoInformado, sentido) {
    this.props.calcularAcrescimoPassagem(valorTotal, acrescimoInformado)
      .then(resp => {
        if (resp.payload.status == 200) {
          this.props.selecionarAcrescimoPassagemInformado(acrescimoInformado);
          if (sentido == 'IDA') {
            this.props.selecionarAcrescimoPassagemCalculado({ida: resp.payload.data, volta: this.props.valorAcrescimoPassagemCalculado.volta })
          } else {
            this.props.selecionarAcrescimoPassagemCalculado({ida:this.props.valorAcrescimoPassagemCalculado.ida, volta: resp.payload.data })
          }
          const valorReserva = this.props.calcularValorTotal()
          this.setState({ valorTotalReserva: valorReserva })
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', valorReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        }
      })
  }

  calcularValorTotal() {
    this.props.calcularValorTotal()
  }

  preencherDadosFormaPagamento() {
    if (this.props.formasPagamento) {
      this.props.formasPagamento.forEach((f) => {
        if (f.tipo === 'Cartão') {
          this.props.changeFieldValue('formReserva',
            'cartao', true);
          this.props.changeFieldValue('formReserva',
            'valorCartao', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
          this.props.changeFieldValue('formReserva',
            'quantideadeParcelas', Number(f.quantideadeParcelas));
          this.props.changeFieldValue('formReserva',
            'numeroComprovante', f.numeroComprovante);
          this.props.changeFieldValue('formReserva',
            'base64Comprovante', f.base64Comprovante);
        }
        if (f.tipo === 'Dinheiro') {
          this.props.changeFieldValue('formReserva',
            'dinheiro', true);
          this.props.changeFieldValue('formReserva',
            'valorDinheiro', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        }
        if(f.tipo === 'PIX') {
          this.props.changeFieldValue('formReserva',
          'pix', true);
        this.props.changeFieldValue('formReserva',
          'valorPIX', f.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
        this.props.changeFieldValue('formReserva',
          'numeroComprovantePIX', f.numeroComprovante);
        this.props.changeFieldValue('formReserva',
          'base64ComprovantePIX', f.base64Comprovante);
        }

        this.props.changeFieldValue('formReserva',
          'tipo', f.tipo);

        this.props.changeFieldValue('formReserva',
          'descontoIda', f.descontoIda);

        this.props.changeFieldValue('formReserva',
          'descontoVolta', f.descontoVolta);
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className='d-flex justify-content-center mt-5'>
          <div className='valorFormaPagamento mr-4'>
            <strong><span>Valor total: </span><span className='ml-2' style={{ color: '#fa8d42' }}>
              {this.props.calcularValorTotalSemTarifaSeguro().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </strong>
          </div>
          <div className='valorFormaPagamento'>
            <strong><span>Valor total com seguro: </span><span className='ml-2' style={{ color: '#fa8d42' }}>
              {this.state.valorTotalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
            </strong>
          </div>
        </div>
        <FormCadastrarFormaPagamento totalReserva={this.state.valorTotalReserva}
          calcularDescontoUsuarioRotaIda={this.calcularDescontoUsuarioRotaIda.bind(this)}
          calcularDescontoUsuarioRotaVolta={this.calcularDescontoUsuarioRotaVolta.bind(this)}
          permiteDescontoUsuarioRotaIda={this.permiteDescontoUsuarioRotaIda.bind(this)}
          permiteDescontoUsuarioRotaVolta={this.permiteDescontoUsuarioRotaVolta.bind(this)}
          calcularAcrescimoPassagemUsuarioIda={this.calcularAcrescimoPassagemUsuarioIda.bind(this)}
          calcularAcrescimoPassagemUsuarioVolta={this.calcularAcrescimoPassagemUsuarioVolta.bind(this)}
          permiteAcrescimoMaximoUsuarioVolta={this.permiteAcrescimoMaximoUsuarioVolta.bind(this)}
          permiteAcrescimoMaxmoUsuarioIda={this.permiteAcrescimoMaxmoUsuarioIda.bind(this)}
          habilitaOuDesabilitaDescontoUsuarioIda={this.habilitaOuDesabilitaDescontoUsuarioIda.bind(this)}
          habilitaOuDesabilitaAcrescimoPassagemIda={this.habilitaOuDesabilitaAcrescimoPassagemIda.bind(this)}
          habilitaOuDesabilitaDescontoUsuarioVolta={this.habilitaOuDesabilitaDescontoUsuarioVolta.bind(this)}
          habilitaOuDesabilitaAcrescimoPassagemVolta={this.habilitaOuDesabilitaAcrescimoPassagemVolta.bind(this)}
          habilitadoDescontoUsuarioIda={this.state.habilitadoDescontoUsuarioIda}
          habilitadoAcrescimoPassagemIda={this.state.habilitadoAcrescimoPassagemIda}
          habilitadoDescontoUsuarioVolta={this.state.habilitadoDescontoUsuarioVolta}
          habilitadoAcrescimoPassagemVolta={this.state.habilitadoAcrescimoPassagemVolta}
          ehRemarcacao={this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0}
          empresaSelecionada={this.props.empresaSelecionada}
          verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado}
        />
      </React.Fragment>
    )
  }
}

export function mapStateToProps(state) {
  return {
    formasPagamento: state.formasPagamento,
    empresaSelecionada: state.empresaSelecionada,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    passageirosIda: state.passageirosIda,
    passageirosVolta: state.passageirosVolta,
    valorDescontoUsuarioCalculado: state.valorDescontoUsuarioCalculado,
    reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
    valorAcrescimoPassagemCalculado: state.valorAcrescimoPassagemCalculado

  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    adicionarFormasPagamento,
    calcularDescontoUsuario,
    selecionarDescontoUsuario,
    selecionarAcrescimoPassagemCalculado,
    calcularAcrescimoPassagem
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formReserva',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaFormaPagamento));
